import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-tn-down",
  "use": "icon-tn-down-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-tn-down\"><path fill=\"#8E8E8E\" d=\"M542.264889 781.767111l422.798222-538.794667A9.500444 9.500444 0 0 0 957.44 227.555556h-92.842667a19.456 19.456 0 0 0-15.132444 7.281777L512 665.088 174.478222 234.837333A19.114667 19.114667 0 0 0 159.288889 227.555556H66.503111a9.557333 9.557333 0 0 0-7.566222 15.416888l422.798222 538.737778a38.513778 38.513778 0 0 0 60.529778 0z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol